import React from "react";
import { Box, Modal, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

export const ImageDetailModal = ({ imageSourceForModal, closeModal }) => {
  return (
    <Modal open={Boolean(imageSourceForModal)} onClose={closeModal}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: { xs: 1, sm: 2 },
          borderRadius: 1,
          width: { xs: "90vw" },
          maxWidth: { xs: "90vw", sm: "90%" },
          // let the box expand more on small screens to nearly full viewport height
          // Use dynamic viewport units on mobile so the modal can fill the screen correctly
          maxHeight: { xs: "calc(100dvh - 8px)", sm: "90%" },
          overflow: "auto",
        }}
      >
        <IconButton
          aria-label="close"
          onClick={closeModal}
          size="small"
          sx={{
            position: "absolute",
            top: 4,
            right: 4,
            backgroundColor: "rgba(0,0,0,0.4)",
            color: "#fff",
            "&:hover": { backgroundColor: "rgba(0,0,0,0.6)" },
          }}
        >
          <Close fontSize="small" />
        </IconButton>
        <Box
          component="img"
          src={imageSourceForModal}
          alt="detail in modal"
          sx={{
            width: "100%",
            height: "auto",
            display: "block",
            // Let the image use the Box's available height so it can fill the modal on mobile
            maxHeight: "100%",
            objectFit: "contain",
          }}
        />
      </Box>
    </Modal>
  );
};
